import UserService from '@/services/user.service.js'
// import { setTimeout } from 'timers'

export default {
  login: (context, data) => {
    context.commit('setLoggingOn', true)
    UserService.login(data.username, data.password)
  },
  logout: context => {
    UserService.logout(res => {
    //   context.commit('setLoader', false, { root: true })
    })
  }
}
